import { connect } from 'react-redux';
import {fetchGameList} from '../services/request.service';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AquilaLogoSvg from '../svgs/AquilaLogoSvg'
import Lottie from 'react-lottie'
import LoginStartBtnSvg from '../svgs/LoginStartBtnSvg.js';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: require('../lottie/kv.json'),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }



const SvgBar = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={44}
      height={36}
      viewBox='0 0 44 36'
      fill="none"
      {...props}
    >
      <path fill="#67FFED" d="M44 0h-8.302L0 36h8.302L44 0Z" />
    </svg>
  )


function Component(props){
    const [list,setlist]=useState([]);
    const navigate = useNavigate();

    async function getList(){
        let response = await fetchGameList()
        if(response?.result){
            setlist(response?.result)
        }
    }

    useEffect(()=>{
        getList()
        const updateInterval= setInterval(()=>{getList()},10000);
        return(() => {
            clearInterval(updateInterval)
        })
    },[])
    

    return(
        <div style={{
            position:'relative',
            display:'flex',
            flexDirection:'column',
            width:'100svw',
            height:'100svh',
            flex:1,
            justifyContent:'flex-start',
            alignItems:'flex-start',
            padding:'60px 2vw',
            boxSizing:'border-box',
            backgroundColor:"rgb(212,212,212)"
        }}> 
            <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,zIndex:0}}>
                <Lottie options={defaultOptions} loop={true} autoplay={true} style={{width:'100%',height:'100%'}} />
                {/* <div style={{position:'absolute',left:'9%',top:'45%'}}>
                    <img src='/bg.png' style={{width:' min( 80svh / 1080 * 1920, 80svw)'}}/>
                </div> */}
                <div style={{position:'absolute',right:'19%',bottom:'30%',fontSize:'min( 3svh / 1080 * 1920, 3svw)',fontWeight:900}}>
                    PART 2
                </div>
            </div>
            <div style={{position:'absolute',top:0,bottom:0,left:0,right:0,zIndex:0,backgroundColor:'#00000030'}}></div>
            <div style={{
                color:'#007D98',fontWeight:'bold',fontSize:24,
                display:'flex',boxSizing:'border-box',flexDirection:'row',
                justifyContent:'flex-start',alignItems:'center',
                width:'100%',
                marginBottom:'12px',
                zIndex:1
            }}>
                <SvgBar/> Game Lobby
            </div>



            {/*Game List Table */}
            
            <div style={{ display:'flex',flexDirection:'column',width:'100%',boxSizing:'border-box',padding:'2vw 0px',gap:'12px',flex:1,overflowY:'auto',backgroundColor:'#FFFFFF',borderRadius:'12px',zIndex:1}}>
            
                <div style={{width:'100%',boxSizing:'border-box',display:'flex',justifyContent:'space-between',fontWeight:"400",borderBottom:'2px solid #23FFF3',paddingBottom:10}}>
                    <div style={{flex:1}}>Name</div>
                    <div style={{flex:1}}>Status</div>
                    <div style={{flex:1}}>Time</div>
                </div>
                {list?.map((item,index)=>
                    <div onClick={()=>{navigate(`/room/${item._id}`);} }key={item?._id||index} style={{width:'100%',boxSizing:'border-box',display:'flex',justifyContent:'space-between',cursor:'pointer',borderBottom:'1px solid white',padding:'12px 0px',fontWeight:'700'}}>
                        <div style={{flex:1}}>{item?.name}</div>
                        <div style={{flex:1}}>{['player-allocate-card','admin-turn','player-due-diligence','player-invest'].includes(item?.status)?'In progress':item.status}</div>
                        <div style={{flex:1}}>{new Date(item?.createDate).toLocaleString()}</div>
                    </div>
                )}          
            </div>
            <div style={{position:'absolute',bottom:'1vw',left:'2vw'}}>
                <AquilaLogoSvg width='150px'/>
            </div>
        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Component)
  



  